
import childrenEdImg1 from '../assets/people-3137672_1280.jpg'
import childrenEdImg3 from "../assets/_DSC1904.jpg";
import childrenEdImg2 from "../assets/children-2142646_1280.jpg";


const ActivitiesComponent = () => {

    return (
        <>
            <section className=" bg-gray-50 py-3.5 px-2  my-2">
                <div className="animate__animated animate__bounceInDown animate__delay-1s lg:w-[50%] lg:m-auto  md:w-[80%] md:m-auto sm:w-[100%] sm:m-0 px-2 py-3.5 ">
                    <h1 className="font-bold text-[26px] text-center py-3.5 uppercase">
                        Presentation de ONFEJ?
                    </h1>
                    <p className="text-center px-2 py-3">
                        ONFEJ est une organisation regroupant des
                        jeunes dynamiques oeuvrant dans le social en
                        Haıẗi depuis une dizaine année et dont la mission consiste
                        àoffrir un avenir meilleur à la jeunesse du
                        pays en priorisant une bonne formation.
                    </p>
                </div>

                <div className="py-4 px-2 w-[100%]  flex justify-center items-center gap-[2rem] flex-wrap lg:flex-row md:flex-row sm:flex-col">

                    <div className='animate__animated animate__backInLeft animate__delay-1s lg:w-[300px] md:w-[100%] sm:w-[100%] rounded-tr-[5px] rounded-tl-[5px] my-2 '>
                        <div className=''>
                            <img
                                src={`${childrenEdImg1}`}
                                alt="Children education"
                                className='lg:w-[300px] md:w-[100%] sm:w-full h-[250px] object-cover rounded-[5px]'
                            />

                        </div>
                        <h1 className='text-[25px] font-bold py-2 text-center px-2'>Éducation des enfants</h1>
                        <p className='text-center px-2 py-2'>
                            L'éducation est la base de tout
                            développement; notre pays souffre depuis
                            des décennies d'un manque de formation, la
                            jeunesse est le pilier du progrès et doit en
                            être le moteur.
                        </p>
                    </div>

                    <div className="animate__animated animate__backInLeft animate__delay-1s lg:w-[300px] md:w-[100%] sm:w-[100%] rounded-tr-[5px] rounded-tl-[5px] my-2">
                        <div>
                            <img
                                src={`${childrenEdImg2}`}
                                alt="Children education"
                                className="lg:w-[300px] md:w-[100%] sm:w-[100%] h-[250px] object-cover rounded-[5px]"
                            />
                        </div>
                        <h1 className="text-[25px] font-bold py-2 text-center px-2">
                            Divertissement
                        </h1>
                        <p className="text-center px-2 py-2">
                            Réaliser des formations dans les
                            domaines suivants: social, culturel,
                            environnemental, réligieux civique.
                            Mettre sur pied des jeux socio-culturels pour des jeunes.
                        </p>
                    </div>

                    <div className="animate__animated animate__backInLeft animate__delay-1s lg:w-[300px] md:w-[100%] sm:w-[100%] rounded-tr-[5px] rounded-tl-[5px] my-2">
                        <div>
                            <img
                                src={`${childrenEdImg3}`}
                                alt="Children education"
                                className="lg:w-[300px] md:w-[100%] sm:w-[100%] h-[250px] object-cover rounded-[5px]"
                            />
                        </div>
                        <h1 className="text-[25px] font-bold py-2 text-center px-2">
                            Formation
                        </h1>
                        <p className="text-center px-2 py-2">
                            Formation en leadership pour des jeunes
                            dans tout les pays, Nous voulons motiver les jeunes à prendre
                            conscience et à agir vite.
                            ‘'Tant vaut l'éducation, tant vaut la nation.''
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ActivitiesComponent